import React from "react";

type Props = {
	main_domain: string;
};

const LegalWarning = (props: Props) => {
	return (
		<div className="safety">
			<h2>Aviso Legal</h2>
			<p>
				<a href={props.main_domain}>{props.main_domain}</a> autoriza al usuario, a tener acceso al presente sitio, siempre
				que acepte en su totalidad los términos, condiciones, advertencias y avisos legales
				contenidos en el mismo.
			</p>
			<p>
				<a href={props.main_domain}>{props.main_domain}</a> no otorga garantia directa o indirecta, en relación con la
				exactitud, confiabilidad u oportunidad de la información, o del material incluido,
				por lo anterior las decisiones que con base en el sitio adopte el usuario serán por
				su cuenta y riesgo.
			</p>
			<p>
				Para efectos de toma de decisiones, <a href={props.main_domain}>{props.main_domain}</a> recomienda contar con la
				asesoría externa que se requiera en cada caso.
			</p>
			<p>
				Este sitio está siendo medido con las soluciones de Google Analytics. Estas
				soluciones utilizan marcas en las páginas y cookies anónimas para analizar lo que
				sucede en nuestras páginas. Para mayor información sobre la política de privacidad
				de Google Analytics ingrese a: <a href="https://support.google.com/analytics/answer/6004245?hl=es&ref_topic=2919631#zippy=%2Cidentificadores-y-cookies-de-google-analytics" target="_blank">Medidas de protección de datos - Google Analytics.</a>
			</p>
			<p>
				Así mismo, las cookies se podrán utilizar con la finalidad de facilitar al máximo su
				navegación en nuestro portal, sin que las mismas proporcionen referencias que
				permitan deducir datos personales ni datos del disco duro de su computador. No
				obstante, puede configurar su computador para que notifique y rechace la instalación
				de las cookies enviadas por {props.main_domain} sin que ello perjudique su acceso a los
				contenidos del portal.
			</p>
		</div>
	);
};

export default LegalWarning;

